<template>
  <div class="b">
    <Nav :current="current"></Nav>
    <div class="titleBox">
      <el-button
        type="primary"
        size="small"
        class="edit l yellow bgBtn"
        @click="addMenuList()"
        >添加功能菜单</el-button
      >
    </div>
    <div class="el-table-box">
      <vxe-table
        border
        resizable
        ref="xTree"
        row-id="id"
        :height="tableHeight"
        highlight-hover-row
        highlight-current-row
        :loading="loading"
        :tree-config="{
          lazy: true,
          children: 'children',
          hasChild: 'hasChild',
          loadMethod: loadChildrenMethod,
        }"
        :data="tableData.data"
      >
        <vxe-table-column
          field="name"
          title="名称"
          width="400"
          tree-node
        ></vxe-table-column>
        <vxe-table-column
          field="sortNum"
          title="排序"
        ></vxe-table-column>
        <vxe-table-column field="isMenu" title="导航菜单"></vxe-table-column>
        <vxe-table-column
          width="200"
          field="extView"
          title="访问选项"
        ></vxe-table-column>
        <vxe-table-column field="opCode" title="引用编号"></vxe-table-column>
        <vxe-table-column field="vip" title="vip"></vxe-table-column>
        <vxe-table-column field="url" title="URL"></vxe-table-column>
        <vxe-table-column field="isBusinessSystem" title="是否启用子系统配置"></vxe-table-column>
        <vxe-table-column field="level" title="level"></vxe-table-column>
        <vxe-table-column width="200"  title="操作">
          <template #default="{ row }">
            <div
              class="link-btn border-right l"

              @click="showModelHandle( row)"
            >
              编辑
            </div>
            <div
              class="link-btn border-right l"
              v-if="tableData.delete"
              @click="showModleDeleteHandle(row)"
            >
              删除
            </div>
            <div
              class="link-btn l"
              v-if="tableData.addsub"
              @click="addMenuSon( row)"
            >
              新建子级菜单
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 弹框 -->
    <vxe-modal v-model="isShowDelete" title="温馨提示" width="300" height="180">
      <vxe-form title-align="right" title-width="100">
        <vxe-form-item align="center" span="24">您确定要删除吗？</vxe-form-item>
        <vxe-form-item align="center" span="24">
          <template #default>
            <vxe-button @click="isShowDelete = false">取消</vxe-button>
            <vxe-button
              style="background: #55c4b8; color: #fff"
              @click="deleHandle"
              >确认</vxe-button
            >
          </template>
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>

    <vxe-modal v-model="showModel" width="600">
      <template #default>
        <vxe-form
          :data="addFormData"
          title-align="right"
          title-width="100"
          @submit="createForm"
        >
          <vxe-form-item
            v-if="modelFormType != 'top'"
            disabled
            title="上级部门"
            field="parentDepartment.name"
            :item-render="{}"
          >
            <template #default>
              <vxe-input
                disabled
                v-model="parentDepartment.name"
                placeholder=""
                clearable
              >
              </vxe-input>
            </template>
          </vxe-form-item>

          <vxe-form-item
            title="部门名称"
            field="addFormData.name"
            :item-render="{}"
          >
            <template #default>
              <vxe-input
                v-model="addFormData.name"
                placeholder="请输入部门名称"
                clearable
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item
            title="职能描述"
            field="addFormData.description"
            :item-render="{}"
          >
            <template #default>
              <vxe-input
                v-model="addFormData.description"
                placeholder="请输入职能描述"
                clearable
              >
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item align="center" span="24">
            <template #default>
              <vxe-button type="submit" status="primary">保存</vxe-button>
              <vxe-button @click="showModel = false">取消</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </template>
    </vxe-modal>
  </div>
</template>
<script>
import http from "@/config/httpConfig";
import apiData from "@/config/api";
import Nav from "@/components/Nav.vue";
function T() {
  return {
    id: "",
    name: "", //部门名字
    description: "", //部门描述
    parentId: "", //部门上级
    parentName: "",
  };
}
export default {
  name: "HelloWorld",
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      current: "公司后台",
      pageSize: 100000,
      loading: false,
      selectRow: null, //当前选中的行
      deleId: "",
      parentId: "",
      tableData: {
        add: true,
        addsub: true,
        edit: true,
        delete: true,
        data: [],
      },
      showModel: false,
      modelFormType: "top",
      parentDepartment: T(),
      addFormData: T(),
      isShowDelete: false, //删除部门
      tableHeight: 400,
      deleteRow: [],
      rowObj: "",
    };
  },
  mounted() {
    this.getList();
    this.getTableHeight();
  },
  methods: {
      showModelHandle(row){
        // localStorage.setItem("EditMenu", JSON.stringify(row))
        let id
        if(row.parentId == true){
            id = row.parentId
        }else{
          id = row.id
        }
      this.$router.push({ name: "EditMenu",  query: { id:id }});
      },

    //   删除
        showModleDeleteHandle: function (row) {
      var _this = this;
      // console.log(row);
      _this.rowObj = row;
      _this.isShowDelete = true;
    },
     // 添加部门
    addDataParent() {
      let _this = this;
      let params = {
        name: _this.addFormData.name,
        description: _this.addFormData.description,
      };
      http.post(apiData.addDepartment, true, params, (res) => {
        if (res.data.code == 200 || _this.name != null) {
          _this.$message.success("");
          _this.showModel = false;
          _this.getList();
        }else{
          _this.$message.success(res.msg);
        }
      });
    },
    addMenuList: function () {
      var _this = this;
      this.$router.push("/company/addMenu");
    },
    addMenuSon(row){
      let _this = this
      // localStorage.setItem("AddMenu", JSON.stringify(row));
      _this.rowObj = this.$router.push({ name: "AddMenu", query: { name:row.name ,parentId:row.id} });
    },
    deleHandle: function () {
      let _this = this;
      let params = {
        id: _this.rowObj.id,
      };
      // console.log('.......')
      http.delete(apiData.menuDelete, true, params, (res) => {
    
        if (res.data.code == 200) {
          _this.$message.success("删除成功");
          _this.isShowDelete = false;
          _this.getList();
        } else {
          // console.log(res.msg)
          _this.$message.error(res.data.msg);
        }
      });
    },

   
    getList: function () {
      var _this = this;
      var params = {
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
      };
      http.get(apiData.menuList, true, params, function (res) {
        if (res.data.data) {
          _this.tableData.data = res.data.data;
        //   console.log("请求", _this.tableData);
        } 
      });
    },
    loadChildrenMethod(row) {
      var _this = this;
      var id = row.row.id;
      var params = {
        parentId: id,
      };
      _this.parentId = id;
      return new Promise((resolve, reject) => {
        console.log(params);
        _this.parentId = id;
        http.get(apiData.companyList, true, params, function (res) {
          if (res.data.data) {
            resolve(res.data.data.list);
          } else {
          }
        });
      })
        .then((res) => {
          console.log(res);
          return res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTableHeight() {
      this.$nextTick(function () {
        this.clientHeight = `${document.documentElement.clientHeight}`;
        // let o = document.querySelector('.bg')
        // let searchHeight = o.clientHeight || o.offsetHeight;
        // let tableHeight = this.clientHeight - 130 - searchHeight;
        this.tableHeight = 500 + "px";
      });
      console.log(this.tableHeight);
    },
  },
};
</script>
<style lang="less">
.b {
  margin: 0 10px;
}
.vxe-form--item-content {
  .vxe-input {
    width: 440px;
  }
}
.b {
  margin: 0 10px;
}
.vxe-form--item-content {
  .vxe-input {
    width: 440px;
  }
}

.b {
  margin: 0 10px;
}

.vxe-form--item-content {
  .vxe-input {
    width: 440px;
  }
}

.vxe-table--render-default .vxe-body--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-footer--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 8px 0 !important;
}
.titleBox {
  display: inline-block;
  width: 100%;
  margin: 10px auto;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;

  .txt {
    display: inline-block;
    margin-right: 10px;
  }
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>